import React, { useState, useEffect, useCallback } from 'react';
import { Table, DatePicker } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import type { ColumnsType } from 'antd/lib/table';
import { flatten } from 'lodash';
// import Dot from '@/components/Dot';
import Chart from '@/business-components/chart';
import Tooltip from '@/components/tooltip';
import Dot from '@/components/Dot';
import CustomEmpty from '@/business-components/CustomEmpty';
import { defaultMonthVal } from '../../../index.page';
import styles from './index.module.scss';

interface IUserPraiseProps {
  data;
  hasUnlock: boolean;
}
const columnsCampany: ColumnsType<any> = [
  {
    title: '品牌名称',
    dataIndex: 'chName',
    align: 'center',
    render: text => (
      <div className={classNames('flex-row-nowrap', 'flex-center-center')}>
        <Dot style={{ marginRight: '4px' }} />
        {text}
      </div>
    ),
    onCell: item => {
      if (item?.rowSpan) {
        return { rowSpan: item.rowSpan };
      } else {
        return {
          colSpan: 0,
        };
      }
      // if (index % 4 === 0) {
      //   return { rowSpan: 4 };
      // }
      // // These two are merged into above cell
      // if (index % 4 === 3) {
      //   return { rowSpan: 0 };
      // }
      // if (index % 4 === 2) {
      //   return { colSpan: 0 };
      // }
      // if (index % 4 === 1) {
      //   return { colSpan: 0 };
      // }
      // return {};
    },
  },
  {
    title: '平台',
    dataIndex: 'dataTypeName',
    align: 'center',
  },
  {
    title: '月份',
    dataIndex: 'countTimeStr',
    align: 'center',
    render(value) {
      return <>{moment(new Date(value)).month() + 1}月</>;
    },
  },
  {
    title: '数值',
    dataIndex: 'value',
    align: 'center',
  },
];
const addRowSpan = list => {
  const listToObj = {};
  list.map(item => {
    if (listToObj[item.conBrandId]) {
      listToObj[item.conBrandId].push(item);
    } else {
      listToObj[item.conBrandId] = [item];
    }
  });

  let newList = [];
  for (const key in listToObj) {
    listToObj[key][0].rowSpan = listToObj[key].length;
    newList = newList.concat(listToObj[key]);
  }
  return newList;
  // console.log(newList);
};
export default function ProductionCapacity({ data, hasUnlock }: IUserPraiseProps) {
  const [viewData, setViewData] = useState<any>(flatten(data?.map(item => item.list)));
  const [dateValue, setDateValue] = useState(defaultMonthVal);
  const [dateRange, setDateRange] = useState([]);
  const disabledDate2 = useCallback(
    (current): boolean => dateRange.every(item => item !== current.format('YYYY-MM')),
    // (current): boolean => {
    //   return (
    //     current.valueOf() < dateRange[0].valueOf() ||
    //     current.valueOf() > dateRange[dateRange?.length - 1 || 0].valueOf()
    //   );
    // },
    [dateRange]
  );
  useEffect(() => {
    const newViewData: any = addRowSpan(
      flatten(data?.map(item => item.list))?.filter(
        (item: any) => moment(item?.countTimeStr).month() === moment(dateValue).month()
      )
    );
    setViewData(newViewData.every(item => !item?.value) ? [] : newViewData);
  }, [data, dateValue]);
  const handleDateChange = val => {
    setDateValue(val);
    // setViewData(
    //   val
    //     ? flatten(data?.map(item => item.list))?.filter(
    //         (item: any) => moment(item?.countTimeStr).month() === moment(val).month()
    //       )
    //     : flatten(data?.map(item => item.list))
    // );
  };
  useEffect(() => {
    const valueDateRange: any = [
      ...new Set(
        flatten(data?.map(item => item.list))
          ?.sort(
            (item: any, itemB: any) =>
              moment(`${item?.countTimeStr}`).valueOf() - moment(`${itemB?.countTimeStr}`).valueOf()
          )
          .map((item: any) => `${item?.countTimeStr}`)
      ),
    ];
    setDateRange(valueDateRange);
    setDateValue(
      valueDateRange.length ? moment(valueDateRange[valueDateRange.length - 1], 'YYYY-MM') : defaultMonthVal
    );
  }, [data, setViewData]);
  return (
    <Chart
      title={
        <span className={styles.title}>
          品牌官号内容量指数
          <Tooltip
            style={{ marginRight: '33px' }}
            title={
              <>
                <p>品牌多平台官方账号发布的内容总数，数据已脱敏处理。</p>
                <p>数据来源：CBNData数据库</p>
              </>
            }
            placement="right"
          />
          {hasUnlock && (
            <DatePicker
              picker="month"
              allowClear={false}
              value={dateValue}
              onChange={handleDateChange}
              disabledDate={disabledDate2}
            />
          )}
        </span>
      }
      panelClassName={styles.userPraiseChart}
    >
      {hasUnlock ? (
        <Table columns={columnsCampany} dataSource={viewData || []} size="small" pagination={false} />
      ) : (
        <CustomEmpty text="已选择的品牌中有未解锁的品牌，请解锁后查看" />
      )}
    </Chart>
  );
}
